module.exports = __webpack_public_path__ + "static/img/20.f960127.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/20.jpg
// module id = Wrgg
// module chunks = 1